/* ============================================================
   CẤU HÌNH THEO SITE — nguồn duy nhất cho mọi khác biệt giữa
   hoanglecf.com và hoanglecf.vn.

   Dữ liệu nằm ở sites.json (JSON thuần) để cả app React lẫn các script Node
   (scripts/build-site.js, deploy) đọc chung một nguồn, không sợ lệch nhau.
   File này chỉ thêm phần logic: chọn site nào đang chạy.

   Hai domain chạy CHUNG một mã nguồn, chung giao diện. Thứ tách chúng ra:
     - domain / canonical / OG
     - tiêu đề, mô tả, từ khóa (trục "thuê acc" cho .com, "thuê nick" cho .vn)
     - displayOn: backend trả về bộ bài viết khác nhau → không đăng trùng bài
     - bộ landing page tĩnh riêng (sites/com/public, sites/vn/public)
     - indexAccGames: MỖI GAME CHỈ ĐƯỢC INDEX TRÊN MỘT DOMAIN.

         .com  →  ["lienquan"]   (Liên Quân là mũi nhọn, CF là phụ)
         .vn   →  ["crossFire"]  (đang mạnh sẵn về Đột Kích/CF, LQ là phụ)

       Hai site dùng chung một kho acc từ API (displayOn chỉ lọc blog, không
       lọc acc). Nếu cả hai cùng cho index trang acc thì mỗi acc có 2 URL nội
       dung y hệt trên 2 tên miền — trùng lặp chéo domain, Google hạ cả hai.

       Chia theo GAME (không phải theo domain) vì mỗi domain đang có thế mạnh
       riêng: .vn đã có thứ hạng về Đột Kích thì để nó giữ, .com dồn cho Liên
       Quân. Game "phụ" vẫn hiện đầy đủ cho người dùng, chỉ khác ở chỗ trang
       acc của nó mang thẻ noindex và không vào sitemap của site đó.

   QUY TẮC: không hard-code "hoanglecf.com" ở bất kỳ đâu trong src/ nữa.
   Cần URL của site thì dùng SITE.baseURL hoặc absoluteUrl(path).
   Ngoại lệ duy nhất: host backend/ảnh (backend.hoanglecf.com) — dùng chung cho
   cả hai site, không phụ thuộc domain người dùng đang truy cập.

   CHỌN SITE: biến build-time REACT_APP_SITE ("com" | "vn"), do
   scripts/build-site.js đặt khi chạy `npm run build:com` / `npm run build:vn`.
   ============================================================ */

import SITES_DATA from "./sites.json";

export const SITES = SITES_DATA;

const DEFAULT_SITE_ID = "com";

/* Suy ra site đang chạy.
   Ưu tiên REACT_APP_SITE vì react-snap prerender bằng Chrome headless trên
   localhost — lúc đó window.location.hostname là "localhost", đoán theo nó sẽ SAI.
   Hostname chỉ là lưới an toàn cho trình duyệt thật (lỡ deploy nhầm bản build
   sang domain kia thì phía client vẫn tự sửa lại). */
function resolveSiteId() {
  const fromEnv = process.env.REACT_APP_SITE;
  if (fromEnv && SITES[fromEnv]) return fromEnv;

  if (typeof window !== "undefined" && window.location) {
    const host = (window.location.hostname || "").replace(/^www\./, "");
    const match = Object.keys(SITES).find((id) => SITES[id].hostname === host);
    if (match) return match;
  }

  return DEFAULT_SITE_ID;
}

export const SITE = SITES[resolveSiteId()];

/* Ghép đường dẫn tương đối thành URL tuyệt đối của site hiện tại.
   absoluteUrl("/thue-acc") → "https://hoanglecf.com/thue-acc" */
export function absoluteUrl(path = "/") {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE.baseURL}${path.startsWith("/") ? path : `/${path}`}`;
}

export const BASE_URL = SITE.baseURL;
export const SITE_NAME = SITE.siteName;

export default SITE;
